import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SortDownFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.48 14L15.8 17.4V4.92H17.56V17.4L20.88 14L21.96 15.04L16.68 20.32L11.4 15.04L12.48 14ZM4.52 7.22V5.38H13.48V7.22H4.52ZM4.52 12.88V11.04H10.48V12.88H4.52ZM4.52 18.62V16.62H8.48V18.62H4.52Z" />
    </SvgIcon>
  );
});
